import script from "./ChartTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTemplates.vue?vue&type=script&setup=true&lang=js"

import "./ChartTemplates.vue?vue&type=style&index=0&id=4c87049c&lang=scss"

const __exports__ = script;

export default __exports__